<template>
  <div
    style="padding:10px;margin-top:10px"
    :class="
      !this.$store.getters.iframeColidee
        ? window.width > 400
          ? 'card'
          : ''
        : 'text-resize-colidee'
    "
  >
    <div class="columns is-mobile is-multiline">
      <div
        :class="
          window.width > 480 && window.width < 1024
            ? 'column is-4-tablet is-6-mobile is-3-desktop'
            : 'column is-4-tablet is-12-mobile is-3-desktop'
        "
        v-for="(evenement, index) in ['addButton', ...evenements_affiche]"
        :key="index"
      >
        <!-- add evenement -->
        <div v-if="evenement === 'addButton'" class="card shadow-card">
          <AddEvenementButton />
        </div>
        <!-- cards list -->
        <div
          v-else
          class="card shadow-card"
          :class="
            evenement.state == false
              ? 'over'
              : evenement.open_at != '1970-01-01 00:00:00' &&
                evenement.open_at != null &&
                new Date(evenement.open_at) &&
                new Date(evenement.open_at) > now
              ? 'programmed'
              : evenement.close_at != '1970-01-01 00:00:00' &&
                evenement.close_at != null &&
                new Date(evenement.close_at) < now
              ? 'over'
              : 'open'
          "
        >
          <div
            :class="!evenement.state ? 'state-closed' : ''"
            class="card-image"
          >
            <div :style="background(evenement.media)"></div>
          </div>
          <div class="">
            <div class="media">
              <div class="media-content">
                <div style="text-align:center">
                  <p
                    :class="!evenement.state ? 'state-closed' : ''"
                    style="position:absolute;top:150px;left:10px;"
                  >
                    {{
                      evenement.created_at
                        .substring(0, 10)
                        .split("-")
                        .reverse()
                        .join("/")
                    }}
                  </p>
                  <p :class="!evenement.state ? 'state-closed' : ''">
                    {{
                      $tc("evenement.attendees.count", evenement.attendees_count, {
                        count: evenement.attendees_count
                      })
                    }}
                  </p>
                  <div
                    style="display:flex;position:absolute;top:150px;right:10px;"
                  >
                    <WhoIsOwner :evenement="evenement" />
                    <ParametersDropdown
                      :cardIndex="index"
                      :evenement="evenement"
                    />
                  </div>
                  <p
                    :class="!evenement.state ? 'state-closed' : ''"
                    style="margin-top:40px;font-size:13px; color:black; font-weight:bold"
                  >
                    {{ evenement.name }}
                  </p>
                  <p :class="!evenement.state ? 'state-closed' : ''">
                    {{
                      evenement.client !== null
                        ? evenement.client
                        : "non renseigné"
                    }}
                  </p>
                  <p
                    style="margin-bottom:5px;"
                    :class="!evenement.state ? 'state-closed' : ''"
                  >
                    {{
                      evenement.evenement !== null
                        ? evenement.evenement
                        : "non renseigné"
                    }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <footer
            :class="!evenement.state ? 'state-closed' : ''"
            class="card-footer"
          >
            <button
              @click="configureDerouleEvenement(evenement.id, evenement.name)"
              class="card-footer-item button button-params"
            >
              {{ $t("evenement.links") }}
            </button>
            <button
              @click="gestionParticipant(evenement.id, evenement.name)"
              class="card-footer-item button button-params"
            >
              {{ $t("evenement.attendees") }}
            </button>
          </footer>
        </div>
      </div>
    </div>
    <b-modal :width="640" v-model="modalQrCode.activeModalQrCode">
      <ModalQrCode :modalQrCode="modalQrCode" />
    </b-modal>

    <b-modal :width="640" v-model="modalShares.activeModalShares">
      <ModalShare :modalShares="modalShares"
    /></b-modal>
    <b-modal :width="640" v-model="modalDuplicate.activeModalDuplicate">
      <ModalDuplicate :modalDuplicate="modalDuplicate" />
    </b-modal>
    <div class=""></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import AddEvenementButton from "@/components/event/components/AddEvenementButton";
import ParametersDropdown from "@/components/event/components/ParametersDropdown";
import ModalQrCode from "@/components/event/components/ModalQrCode";
import ModalShare from "@/components/event/components/ModalShare";
import ModalDuplicate from "@/components/event/components/ModalDuplicate";
import WhoIsOwner from "@/components/event/components/WhoIsOwner";

export default {
  name: "CardsList",
  components: {
    AddEvenementButton,
    ParametersDropdown,
    ModalQrCode,
    ModalShare,
    ModalDuplicate,
    WhoIsOwner
  },
  props: ["window"],
  updated() {
    this.$nextTick(function() {
      let message = {
        task: "updateHeight",
        height: document.body.scrollHeight
      };
      window.top.postMessage(message, "*");
    });
  },
  mounted() {
    this.$store.commit("CLEAR_FIELDS");
    this.$store.dispatch("getEvenements");
    if (this.$store.state.evenement.search_query.length) {
      this.$store.commit("ADMIN_ACTIVE_COMPONENTS", {
        searchBar: true,
        cardList: true,
        parameters: false
      });
    }
  },
  computed: {
    ...mapGetters([
      "evenements_affiche",
      "modalQrCode",
      "modalShares",
      "modalDuplicate",
      "modalExportExcelPdf"
    ]),
    now: function() {
      return new Date();
    }
  },
  methods: {
    configureDerouleEvenement(evenement_id, evenement_name) {
      this.$store.commit("CONFIGURE_LINKS_EVENEMENT_NAME", evenement_name);
      this.$store.commit("CONFIGURE_LINKS_EVENEMENT", evenement_id);
      this.$router.push({ name: "AdminLinks" });
    },
    gestionParticipant(evenement_id, evenement_name) {
      this.$store.commit("CONFIGURE_LINKS_EVENEMENT_NAME", evenement_name);
      this.$store.commit("CONFIGURE_LINKS_EVENEMENT", evenement_id);
      this.$router.push({ name: "AdminAttendees" });
    },

    background(urlMedia) {
      if (urlMedia === null || urlMedia === undefined) {
        if (window.width < 480) {
        }
        return (
          "height:130px; width:100%; background-size: cover;background-position: center;background-image:url(" +
          require("@/assets/img/medaillonsondages.png") +
          ")"
        );
      } else {
        return (
          "height:130px; width:100%;background-size: cover;background-position: center;background-image:url(" +
          process.env.URL_MEDIA +
          urlMedia +
          ")"
        );
      }
    },
    deleteEvenement(idEvenement) {
      this.$buefy.dialog.confirm({
        cancelText: this.$i18n.t("common.non"),
        confirmText: this.$i18n.t("common.oui"),
        message: this.$i18n.t("common.confirm-delete"),
        onConfirm: () => this.$store.dispatch("delete_evenement", idEvenement)
      });
    }
  }
};
</script>
<style scoped>
.white_space_200 {
  height: 200px;
}
.button {
  border-color: none;
  border-radius: 0px;
  font-size: 12px;
  height: 100%;
  color: black;
}
.button:hover {
  border-color: none;
  border-radius: 0px;
  font-size: 12px;
  height: 100%;
  text-decoration: none;
}
.button:disabled {
  border-color: none;
  color: currentColor;
  cursor: not-allowed;
  opacity: 0.5;
  text-decoration: none;
  font-size: 12px;
  height: 100%;
  color: white;
}
.shadow-card {
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
}
.state-closed {
  opacity: 0.3;
}
.button-delete {
  padding: 5px 7px;
  background-color: #e6ecf0;
}
.button-delete:hover {
  background-color: red;
  color: white;
}
.button-params {
  padding: 5px 7px;
  background-color: #e6ecf0;
}
.button-params:hover {
  background-color: #424a60;
  color: white;
}
.text-resize-colidee {
  font-size: 10px;
}
.open {
  border-top: 2px solid green;
}
.over {
  border-top: 2px solid red;
}
.programmed {
  border-top: 2px solid orange;
}
</style>



// WEBPACK FOOTER //
// src/components/event/CardsList.vue